// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2EPB8","additionalInfo":"AgreementModal_additionalInfo__1r6x9"};